<template>
  <div class="yxp-uploader">
    <slot name="overTips" />
    <button
      v-if="fileBtn"
      class="btn upload-btn"
      :class="className"
      type="button"
      @click.stop.prevent="handleClick"
    >
      {{ btnName }}
    </button>
    <input
      :id="uploaderId"
      ref="input"
      type="file"
      name="yxpuploader"
      :multiple="multiple"
      :accept="accept"
      :limit="limit"
      :capture="capture"
      @change="handleChange"
    >
    <slot name="underTips" />
  </div>
</template>

<script>
// 每次上传的字节数
import { api3 } from './api.js';
const oneMB = 1048576; // 1MB 的 字节数
const uploadSize = oneMB / 2;
export default {
    name: 'UploadResume',
    props: {
        'uploaderId': {
            type: String,
            required: true,
        },
        'theme': {
            type: String,
            required: false,
            default: '',
        },
        'accept': {
            type: String,
            required: false,
            default: '',
        },
        'fileList': {
            type: Array,
            required: true,
            default () {
                return [];
            },
        },
        'btnName': {
            type: String,
            required: false,
            default: '请选择文件',
        },
        'className': {
            type: String,
            required: false,
            default: '',
        },
        'autoUpload': {
            type: Boolean,
            required: false,
            default: false,
        },
        'maxSize': {
            type: Number,
            required: false,
            default: 1024 * 10, // 单位kb
        },
        'fileBtn': {
            type: Boolean,
            required: false,
            default: true,
        },
        'uploadModeType': {
            type: String,
            required: false,
            default: '',
        },
        'uploadUrl': {
            type: String,
            required: false,
            default: '',
        },
        // 多媒体动作（json字符串）
        'multimedia': {
            type: String,
            required: false,
            default: '',
        },
        'capture': {
            type: String,
            required: false,
            default: undefined,
        },
        'uploadConfig': {
            type: Array,
            required: false,
            default () {
                return [];
            },
        },
        'limit': {
            type: Number,
            required: false,
            default: 1,
        },
    },
    data () {
        return {
            fails: [],
        };
    },
    computed: {
        multiple () {
            return this.limit > 1;
            // return false;
        },
        readyList () {
            return this.fileList.filter(r => {
                return r.status === 'ready';
            });
        },
        uploadingList () {
            return this.fileList.filter(r => {
                return r.status === 'uploading';
            });
        },
    },
    mounted () {

    },
    methods: {
        showMaxSize (maxSize) {
            if (maxSize <= 1024) {
                return maxSize + 'KB';
            } else {
                return Math.round(maxSize / 1024).toFixed(1) + 'MB';
            }
        },
        checkType (rawFile) {
            let accept = this.accept.toLowerCase();
            let accept_ = [];
            if (this.uploadConfig.length) {
                this.uploadConfig.map(r => {
                    r.accept && accept_.push(r.accept);
                });
            }
            accept_ && (accept = accept.toString());
            var extName = rawFile.name.substring(rawFile.name.lastIndexOf('.') + 1);
            extName = extName.toLowerCase();

            var s2 = accept.toLowerCase();
            s2 = s2.replace(/(\.|\*|image\/|video\/|audio\/)/ig, '');
            s2 = s2.split(',');

            var s3 = accept_.toString().toLowerCase();
            s3 = s3.replace(/(\.|\*|image\/|video\/|audio\/)/ig, '');
            s3 = s3.split(',');

            if (s2.indexOf(extName) !== -1 || s3.indexOf(extName) !== -1) {
                return true;
            } else {
                console.log(s2, s3, extName);
                return false;
            }
        },
        // 格式化 filelist
        formatFileList (upFiles) {
            var that = this;
            var item;
            let uploadConfig = null;
            let extName = '';
            let auth = true;
            for (var i = 0; i < upFiles.length; i++) {
                item = upFiles[i];
                // 取配置
                extName = item.name.substring(item.name.lastIndexOf('.') + 1);
                uploadConfig = this.uploadConfig.find(r => {
                    let acc = r.accept.toLowerCase();
                    acc = acc.replace(/(\.|\*|image\/|video\/|audio\/)/ig, '');
                    acc = acc.split(',');
                    return acc.includes(extName.toLowerCase());
                });

                // 判断后缀，格式不对报错，并执行下一条
                if (!this.checkType(item)) {
                    let errorTip = '文件【' + item.name + '】格式不对';
                    this.fails.push({ 'status': 'fail', 'tips': errorTip, 'errType': 'err_type', rawFile: item });
                    continue;
                }
                // 判断大小，0kb报错，并执行下一条
                if (item.size <= 0) {
                    let errorTip = '空文件，上传失败';
                    this.fileList.push({ 'status': 'empty', 'tips': errorTip, 'errType': 'empty_file', rawFile: item });

                    continue;
                }

                // 判断大小，超大就报错，并执行下一条
                if (item.size > (uploadConfig && uploadConfig.maxSize ? 1024 * uploadConfig.maxSize : 1024 * this.maxSize)) {
                    let errorTip = '文件【' + item.name + '】大小超过' + this.showMaxSize((uploadConfig && uploadConfig.maxSize || this.maxSize));
                    this.fails.push({ 'status': 'fail', 'tips': errorTip, 'errType': 'over_max_size', rawFile: item });

                    continue;
                }

                // 文件名长度，超长就报错，并执行下一条
                if (uploadConfig.fileNameLimit && item.name.replace('.' + extName, '').length > uploadConfig.fileNameLimit) {
                    let errorTip = '文件名【' + item.name + '】超过' + uploadConfig.fileNameLimit + '个字符';
                    this.fails.push({ 'status': 'fail', 'tips': errorTip, 'errType': 'over_name_limit', rawFile: item });
                    continue;
                }

                // 判断数量，超量就报错，并停止执行
                if (this.fileList.length >= this.limit) {
                    let errorTip = '文件数量不能超过' + this.limit + '个';
                    this.fails.push({ 'status': 'fail', 'tips': errorTip, 'errType': 'over_max_limit', rawFile: item });
                    break;
                }

                /*
                // 在列表中找不到相同文件加入
                getMd5(item).then(md5 => {
                    if (that.fileList.findIndex((one) => { return one.md5 !== md5; }) !== -1) {
                        that.fileList.push({ rawFile: item, url: '', md5: '', status: 'ready', progress: 0, downUrl: '', tips: '', result: {} });
                    }
                });
                */

                if (uploadConfig) {
                    auth = typeof uploadConfig.auth !== 'undefined' ? uploadConfig.auth : true;
                }

                // 把所选文件都加入列表
                let options = {
                    onSucc: this.onSucc,
                    onFail: this.onFail,
                    uploadModeType: (uploadConfig && uploadConfig.uploadModeType) || this.uploadModeType,
                    multimedia: (uploadConfig && uploadConfig.multimedia) || this.multimedia,
                    auth: auth,
                };
                that.fileList.push({ rawFile: item, url: '', md5: '', status: 'ready', currentUpSize: 0, progress: 0, downUrl: '', tips: '', result: {}, options: options });
            }
            this.$refs.input.value = null;
        },
        handleClick () {
            this.$refs.input.click();
        },
        handleChange (e) {
            let files = e.target.files;
            this.fails = [];
            if (!files) return;

            let upFiles = Array.prototype.slice.call(files);
            if (upFiles.length === 0) { return; }
            console.log('handleChange', upFiles, upFiles[0].name);

            // this.fileList.splice(0);
            this.formatFileList(upFiles);
            this.$emit('onChange', this.fileList);
            if (this.fails.length) {
                this.fails.forEach(item => {
                    this.$emit('onFail', item);
                });
            }
            if (this.autoUpload && this.fileList.length) {
                this.submit();
            }
        },
        handleRemove () {
            this.$emit('onChange');
        },
        onSucc (file) {
            this.$emit('onSucc', file);
            console.log('成功', file);
        },
        onFail (file) {
            this.$emit('onFail', file);
            console.log('失败', file);
        },
        // 上传
        submit () {
            // this.prepare();
            this.uploadQuene();
        },

        uploadQuene () {
            // 并发上传
            let concurrency = 1;
            if (this.uploadingList.length < 4 && this.readyList.length > 0) {
                let newNumber = concurrency - this.uploadingList.length;
                for (var i = 0; i < this.readyList.length && i < newNumber; i++) {
                    this.prepare(this.readyList[i]);
                }
            }
        },

        // 初始化参数
        async prepare (fileInfo) {
            // let fileInfo = this.fileList[0];
            if (!fileInfo) {
                return;
            }
            const rawFile = fileInfo.rawFile;
            fileInfo.progress = 0;
            fileInfo.status = 'ready';
            const showMD5Progress = rawFile.size > oneMB * 20; // 文件大于20M显示解析MD5的过程
            if (showMD5Progress) {
                fileInfo.tips = '正在计算文件md5，请稍等…';
            } else {
                fileInfo.tips = '文件正在上传，请稍等…';
            }
            // this.rawFile = rawFile;
            fileInfo.md5 = await this.getMd5(fileInfo, progress => {
                if (showMD5Progress) {
                    fileInfo.progress = Math.floor(progress * 1000) / 10;
                }
            });
            this.bmf = null;
            if (!fileInfo.md5) {
                fileInfo.status = 'fail';
                fileInfo.tips = 'md5解析出错，请重试';
                return;
            }
            if (!showMD5Progress) {
                this.getChunkedFileSize(fileInfo);
            } else {
                setTimeout(() => {
                    this.getChunkedFileSize(fileInfo);
                }, 300);
            }
        },
        // 获取已经上传的文件大小
        getChunkedFileSize (fileInfo) {
            // let fileInfo = this.fileList[0];
            if (!fileInfo) {
                return;
            }
            fileInfo.status = 'ready';
            fileInfo.progress = 0;
            fileInfo.tips = '文件正在上传，请稍等…';
            const param = {
                options: {
                    url: `/file/getChunkedFileSize?md5=${fileInfo.md5}&fileSize=${fileInfo.rawFile.size}`,
                },
            };
            // fileStatus: 文件上传状态 1-未上传，2-上传中，3-已上传
            api3.getChunkedFileSize(param).then(res => {
                if (res.errcode === 0) {
                    fileInfo.currentUpSize = Number(res.data.fileSize);
                    if (fileInfo.currentUpSize < 0) fileInfo.currentUpSize = 0;
                    if (res.data.fileStatus !== 3) {
                        this.startTime = null;
                        fileInfo.status = 'uploading';
                        fileInfo.progress = Math.floor(fileInfo.currentUpSize / fileInfo.rawFile.size * 1000) / 10;
                        this.uploadResume(fileInfo);
                    } else {
                        // 解压
                        fileInfo.result = res.data;
                        fileInfo.progress = 100;
                        fileInfo.downUrl = res.data.fileUrl + '?withOriginName=true&download=true';
                        fileInfo.url = res.data.fileUrl;
                        fileInfo.status = 'succ';
                        fileInfo.tips = '文件上传成功';
                        if (this.readyList.length) {
                            this.uploadQuene();
                        }
                        this.onSucc(fileInfo);
                    }
                } else {
                    // this.$message.error(res.errmsg);
                    fileInfo.status = 'fail';
                    fileInfo.rawFile = null;
                    if (this.readyList.length) {
                        this.uploadQuene();
                    }
                    this.onFail(fileInfo);
                }
            });
        },

        // 断点续传
        uploadResume (fileInfo) {
            // let fileInfo = this.fileList[0];
            if (!fileInfo) {
                return;
            }
            fileInfo.percent = Math.floor(fileInfo.currentUpSize * 1000 / fileInfo.rawFile.size) / 10;
            if (this.isAbort) return;
            const offset = fileInfo.currentUpSize;
            let rangeEnd;
            if (fileInfo.rawFile.size - offset < uploadSize * 2) {
                rangeEnd = fileInfo.rawFile.size - 1;
            } else {
                rangeEnd = offset + uploadSize - 1;
            }
            const formData = new FormData();
            // if (fileInfo.rawFile.size === rangeEnd + 1) { // 最后一次上传，range不能减1，不然上传的文件会少一个字节
            //     rangeEnd += 1;
            // }
            formData.append('file', fileInfo.rawFile.slice(offset, rangeEnd + 1));

            let uploadModeUrl = '';
            uploadModeUrl = (this.uploadUrl || '/file/upload/') + ((fileInfo.options && fileInfo.options.uploadModeType) || this.uploadModeType || 'avatar');

            const param = {
                options: {
                    url: `${uploadModeUrl}?md5=${fileInfo.md5}&fileSize=${fileInfo.rawFile.size}&fileName=${fileInfo.rawFile.name}`,
                    Range: `bytes=${offset}-${rangeEnd}`,
                    contentType: 'multipart/form-data;boundary=' + new Date().getTime(),
                    data: formData,
                    setCancel: (c) => { fileInfo.options.cancel = c; },
                },
            };
            api3.uploadResume(param).then(res => {
                if (res.errcode === 0) {
                    fileInfo.currentUpSize = Number(res.data.uploadFileSize);
                    if (fileInfo.currentUpSize < fileInfo.rawFile.size - 1) {
                        fileInfo.status = 'uploading';
                        fileInfo.progress = Math.round(fileInfo.currentUpSize / fileInfo.rawFile.size * 100) / 10;
                        this.uploadResume(fileInfo);
                    } else {
                        fileInfo.result = res.data;
                        fileInfo.progress = 100;
                        fileInfo.downUrl = res.data.fileUrl + '?withOriginName=true&download=true';
                        fileInfo.url = res.data.fileUrl;
                        fileInfo.status = 'succ';
                        fileInfo.tips = '文件上传成功';
                        if (this.readyList.length) {
                            this.uploadQuene();
                        }
                        this.onSucc(fileInfo);
                        console.log('上传完成');
                    }
                } else {
                    if (res.errcode === 1999) {
                        fileInfo.status = 'cancel';
                    } else {
                        this.$message({
                            message: res.errmsg,
                            type: 'error',
                        });
                        fileInfo.status = 'fail';
                        // fileInfo.rawFile = null;
                        if (this.readyList.length) {
                            this.uploadQuene();
                        }
                        this.onFail(fileInfo);
                    }
                }
            });
            // Stream文件断点续传 模块分组 + 类型 http://yapi.dev.anoah.com/project/549/interface/api/31699
            // window.axios({
            //     url: `${this.host}file//beike/beikePackage`,
            //     method: 'post',
            //     data: formData, // body参数
            //     params: { fileName: this.rawFile.name, fileSize: this.rawFile.size, md5: this.md5 }, // query参数
            //     headers: {
            //         'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime(),
            //         'Range': `bytes=${offset}-${rangeEnd}`,
            //         'authorization': window.yxpapi.store.state.global.loginInfo.jwt,
            //         'orgId': window.yxpapi.store.state.global.loginInfo.orgId,
            //     },
            // }).then(res => {
            //     if (this.isAbort) return;
            //     if (res.data.errcode === 0) {
            //         this.currentUpSize = rangeEnd;
            //         if (this.currentUpSize < this.rawFile.size) {
            //             this.uploadResume();
            //         } else {
            //             this.progress.percent = 100;
            //             setTimeout(() => {
            //                 this.savePackage(res.data.data.fileUrl);
            //             }, 300);
            //         }
            //     } else {
            //         this.$message.error(res.data.errmsg);
            //         this.progress.status = 'exception';
            //         this.progress.explain = '上传失败了，请重新上传';
            //         this.rawFile = null;
            //     }
            // });
        },

        // 计算md5
        getMd5 (itemFile) {
            let i = 0; // 计时器
            let sizePerSecond = 20 * 1024 * 1024 / 10; // 预计每秒处理容量，每秒20M
            return new Promise((resolve, reject) => {
                let getMd5Timer = setInterval(function () {
                    i++;
                    let progress = sizePerSecond * i / itemFile.rawFile.size;
                    progress = progress > 1 ? 1 : progress;
                    itemFile.progress = (Math.round((progress * 0.1 * 10000)) / 100).toFixed(1);
                    // console.log('md5 progress', progress, itemFile.progress);
                }, 100);

                // 计算md5
                window.browserMD5File(itemFile.rawFile, (err, md5) => {
                    getMd5Timer && clearInterval(getMd5Timer);
                    if (err) {
                        resolve({ 'status': false }, err);
                    } else {
                        itemFile.progress = (Math.round(0.1 * 10000) / 100).toFixed(1);
                        resolve(md5);
                    }
                });
            });
        },

        /**
         * 随机生成id
         * @param n 默认32位
         * @returns {string}
         */
        randomId (n = 32) {
            let s = '';
            Array.from({ length: n }).forEach((v, i) => {
                let r = Math.floor(Math.random() * 36);
                if (r < 10) {
                    s += r;
                } else {
                    s += String.fromCharCode(r + 87);
                }
                if ([7, 11, 15, 19].includes(i)) s += '-';
            });
            return s;
        },
    },

};

</script>

<style lang="scss" scoped>
  .yxp-uploader{
        .btn{
            outline: none;
            &.upload-btn{
                width:80px;
                border: none;
                padding:4px 10px;
                border-radius: 4px;
                cursor: pointer;
                background-color:#2FD095;
                color:#fff;
            }
            &.upload-btn:hover{
                background-color:rgb(28, 151, 106);
            }
        }
        input{
            display:none;
        }
    }
</style>
